export class Education {
    degree: string = '';
    university: string = '';
    endDate: string = '';
}